import { v4 as uuidv4 } from 'uuid';

import Individual, { IndividualBase } from "../types/individual";

export function makeNewIndividualBase(): IndividualBase {
  return {
    id: uuidv4(),
    selected: false,
  };
}

export function createNewPopulationId(): string {
  return uuidv4();
}

type Primitive = string | boolean | number;
export function genomesAreEqual(ind1: { genome?: Primitive }, ind2: { genome?: Primitive }) : boolean {
  return ind1.genome === ind2.genome;
}

export function individualIsUnique(individual : Individual, individuals : Individual[]) : boolean {
  return !individuals.find((i) => genomesAreEqual(i, individual));
}

export function individualIsNonEmpty(individual : Individual) : boolean {
  return !!individual?.genome?.match(/\w/);
}
